import { useLang } from "@/i18n/LangContext";
import { IMAGES } from "@/lib/images";

export default function Hero() {
  const { t } = useLang();
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[92vh] w-full overflow-hidden"
    >
      <div
        className="absolute inset-0 hero-bg"
        style={{ backgroundImage: `url(${IMAGES.hero})` }}
        aria-hidden
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#121C26]/85 via-[#121C26]/35 to-[#121C26]/30" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 pt-40 pb-24 min-h-[92vh] flex flex-col justify-end">
        <p
          data-testid="hero-overline"
          className="text-xs uppercase tracking-overline text-white/85 mb-6 fade-up"
        >
          {t.hero.overline}
        </p>
        <h1
          data-testid="hero-title"
          className="font-serif text-white text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight max-w-4xl whitespace-pre-line fade-up"
          style={{ animationDelay: "0.1s" }}
        >
          {t.hero.title}
        </h1>
        <p
          data-testid="hero-subtitle"
          className="mt-8 text-white/85 text-base sm:text-lg max-w-xl leading-relaxed fade-up"
          style={{ animationDelay: "0.25s" }}
        >
          {t.hero.subtitle}
        </p>
        <div
          className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4 fade-up"
          style={{ animationDelay: "0.35s" }}
        >
          <a
            data-testid="hero-book-btn"
            href="#availability"
            className="inline-flex items-center px-7 py-3.5 rounded-full bg-[#FAF9F6] text-[#1A3B4D] text-sm tracking-wide hover:bg-white transition-colors"
          >
            {t.hero.cta}
            <span className="ml-2">→</span>
          </a>
          <a
            data-testid="hero-discover-btn"
            href="#suite"
            className="inline-flex items-center px-7 py-3.5 rounded-full border border-white/40 text-white text-sm tracking-wide hover:bg-white/10 transition-colors"
          >
            {t.hero.secondary}
          </a>
        </div>
      </div>
    </section>
  );
}
